import { ReactComponent as Copy } from "./svg/icon-copy.svg";

export const IconCopy = () => <Copy />;
